import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import ABISubmissions from '../component/list/ABISubmissions';

// const fullTitle = 'Entry Summary';
// const shortTitle = fullTitle;
// const BCrumb = [
//   { title: "ABI" },
//   { title: shortTitle, },
// ];

function EditPage(props) {

  return (
    <ScopedCssBaseline>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        In progress..
      </Box>
    </ScopedCssBaseline>);
};

export default EditPage;